/**
 * `Sheet`'s LEGACY chrome: the header and the phone's handle exactly as the live My Orders sheets draw
 * them, on the frozen `COLORS` (DESIGN_SYSTEM.md §7.2, QD5). The default `appearance`; the frame is the
 * roles' (`look.ts`) for every caller. Deleted when My Orders moves onto roles (DS3).
 *
 * legacy-look: check R allows this file `COLORS`, and lists it for review.
 */
import { COLORS } from "@rista/ui/library/theme/tokens";
import { defineVariants } from "@rista/ui/library/theme/variants";

export const sheetLegacyLook = defineVariants({
  slots: ["header", "title", "subtitle", "handle"],
  base: () => ({
    header: { padding: 20, borderBottomWidth: 1, borderBottomColor: COLORS.SHEET_RULE },
    title: { fontSize: 20, fontWeight: "700", color: COLORS.SHEET_TITLE },
    subtitle: { fontSize: 14, color: COLORS.SHEET_SUBTITLE, marginTop: 4 },
    handle: { backgroundColor: COLORS.SHEET_HANDLE, width: 48 },
  }),
});
